import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetServiceProps } from "@api/types/globalService.types";

export const useGetAllDefaultTemplateServices = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const allDefaultTemplateService = useQuery({
    queryKey: [CACHE_KEYS.DEFAULT_ALERT_TEMPLATE, page, per_page],
    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: URLS.DEFAULT_ALERT_TEMPLATES,
        searchParams: {
          page: page,
          include: "alert",
          per_page: per_page,
        },
      });
    },
    enabled: enableQuery,
  });
  return {
    services: { allDefaultTemplateService },
  };
};
